'use strict';

angular.module('licensure.helpers')
    .factory('LocalDatabase', ['$rootScope', '$q', function ($rootScope, $q) {
        var DB_NAME = 'licensuredb',
            DB_VERSION = 1,
            dbDeferred = $q.defer(),
            database,
            filesystem,
            licensuredb = null,
            keyPaths = {
                list: 'state',
                license: 'id',
                query: 'state',
                visit: 'id',
                inspection: 'id',
                account: 'PRODUCTNAME',
                enterprise: 'PRODUCTNAME',
                portal_permission: 'PRODUCTNAME',
                inspection_status: 'id',
                year: 'MODULENAME'
            },
            merge_sort = function (items, index) {

                if (!items || items === null || typeof items === 'undefined' || items.length == 0) {
                    return [];
                }

                if (items.length < 2) {
                    return items;
                }

                var middle = Math.floor(items.length / 2),
                    left = items.slice(0, middle),
                    right = items.slice(middle);

                return merge(merge_sort(left, index), merge_sort(right, index), index);
            },
            merge = function (left, right, index) {
                var result = [],
                    il = 0,
                    ir = 0;
                while (il < left.length && ir < right.length) {
                    if (left[il][index] < right[ir][index]) {
                        result.push(left[il++]);
                    } else {
                        result.push(right[ir++]);
                    }
                }

                return result.concat(left.slice(il)).concat(right.slice(ir));
            },
            onInitFs = function (fs) {
                console.log('The file system has been initialized.');
                filesystem = fs;
            },
            errorHandler = function (e) {
                var msg = '',
                    FileError = window.FileError;
                switch (e.code) {
                    case FileError.QUOTA_EXCEEDED_ERR:
                        msg = 'QUOTA_EXCEEDED_ERR';
                        break;
                    case FileError.NOT_FOUND_ERR:
                        msg = 'NOT_FOUND_ERR';
                        break;
                    case FileError.SECURITY_ERR:
                        msg = 'SECURITY_ERR';
                        break;
                    case FileError.INVALID_MODIFICATION_ERR:
                        msg = 'INVALID_MODIFICATION_ERR';
                        break;
                    case FileError.INVALID_STATE_ERR:
                        msg = 'INVALID_STATE_ERR';
                        break;
                    default:
                        msg = 'Unknown Error';
                        break;
                }
                console.log('There was an error requesting access to the file system: ' + msg);
            },
            getFileURL = function (file) {
                var deferredFileURL = $q.defer();
                if (file.CONTENT !== null) {
                    deferredFileURL.resolve(window.URL.createObjectURL(file.CONTENT));
                } else {
                    filesystem.root.getFile(file.FILE_NAME, {}, function (fileEntry) {
                        deferredFileURL.resolve(fileEntry.toURL());
                    }, function (e) {
                        deferredFileURL.reject(e); console.log('error --> ', e);
                    });
                }
                return deferredFileURL.promise;
            },
            writeFileToStorage = function (file) {
                var deferredFile = $q.defer();
                if (filesystem) {
                    filesystem.root.getFile(file.FILE_NAME, {
                        create: true
                    }, function (fileEntry) {
                        fileEntry.createWriter(function (fileWriter) {
                            fileWriter.onwriteend = function () {
                                file.CONTENT = null;
                                deferredFile.resolve(file);
                            };
                            fileWriter.onerror = function (event) {
                                console.log('There was an error writing the file to the file system.');
                                deferredFile.reject(event);
                            };
                            fileWriter.write(file.CONTENT);
                        });
                    }, function (e) {
                        deferredFile.reject(e); console.log('error --> ', e);
                    });
                } else {
                    deferredFile.resolve(file);
                }
                return deferredFile.promise;
            },
            deleteFileFromStorage = function (fileName) {
                var d = $q.defer();
                if (filesystem) {
                    filesystem.root.getFile(fileName, {
                        create: false
                    }, function (fileEntry) {
                        fileEntry.remove(function () {
                            d.resolve();
                        }, function (e) {
                            console.log(e);
                            d.resolve(e);
                        });
                    }, function (e) {
                        console.log(e);
                        d.resolve();
                    });
                } else {
                    d.resolve();
                }
                return d.promise;
            },
            openDB = function () {
                $rootScope.offlineDBOn = true;
                
                var emptydb = {};
                if (licensuredb == null) {
                    licensuredb = {};
                    try {
                        licensuredb.list = new Dexie('list');
                        licensuredb.list.version(1).stores({ record: "" });
                        licensuredb.list.open();

                        licensuredb.license = new Dexie('license');
                        licensuredb.license.version(1).stores({ record: "" });
                        licensuredb.license.open();

                        licensuredb.query = new Dexie('query');
                        licensuredb.query.version(1).stores({ record: "" });
                        licensuredb.query.open();

                        licensuredb.visit = new Dexie('visit');
                        licensuredb.visit.version(1).stores({ record: "" });
                        licensuredb.visit.open();

                        licensuredb.inspection = new Dexie('inspection');
                        licensuredb.inspection.version(1).stores({ record: "" });
                        licensuredb.inspection.open();

                        licensuredb.account = new Dexie('account');
                        licensuredb.account.version(1).stores({ record: "" });
                        licensuredb.account.open();

                        licensuredb.enterprise = new Dexie('enterprise');
                        licensuredb.enterprise.version(1).stores({ record: "" });
                        licensuredb.enterprise.open();

                        licensuredb.portal_permission = new Dexie('portal_permission');
                        licensuredb.portal_permission.version(1).stores({ record: "" });
                        licensuredb.portal_permission.open();

                        licensuredb.inspection_status = new Dexie('inspection_status');
                        licensuredb.inspection_status.version(1).stores({ record: "" });
                        licensuredb.inspection_status.open();

                        licensuredb.year = new Dexie('year');
                        licensuredb.year.version(1).stores({ record: "" });
                        licensuredb.year.open();
                    }
                    catch (e) {
                        console.log('Caching not available');
                        $rootScope.offlineDBOn = false;
                        return;
                    }
                }
            },
            getDB = function () {
                return licensuredb;
            };
        openDB();
        return {
            openTheDB: function () {
                openDB();
            },
            get: function (collection, key) {
                var d = $q.defer();

                try {
                    licensuredb[collection].record.get(key, function (item) {
                        d.resolve(item);
                    }).catch(function (error)
                    {
                        console.log("lawnchair cache", error);
                        licensuredb[collection].delete();
                        window.location.reload();
                        d.reject(error);
                    });
                } catch (e) {
                    console.log('error --> ', e);
                    d.reject(e);
                }

                return d.promise;
            },
            put: function (collection, blob) {
                var d = $q.defer();

                try {
                    blob.key = blob[keyPaths[collection]];
                    licensuredb[collection].record.put(blob, blob.key);
                    d.resolve();
                } catch (e) {
                    console.log('error --> ', e);
                    d.reject(e);
                }
                return d.promise;
            },
            putWithIndex: function (collection, i, key, blob) {
                var d = $q.defer();

                try {
                    if (licensuredb[collection])
                        licensuredb[collection].record.put(blob, key);
                    d.resolve();
                } catch (e) {
                    console.log('error --> ', e);
                    d.reject(e);
                }

                return d.promise;
            },
            remove: function (collection, key) {
                var d = $q.defer();

                try {
                    licensuredb[collection].record.delete(key);
                    d.resolve();
                } catch (e) {
                    console.log('error --> ', e);
                    d.reject(e);
                }

                return d.promise;
            },
            removeWithIndex: function (collection, i, key) {
                var d = $q.defer();

                try {
                    licensuredb[collection].record.delete(key);
                    d.resolve();
                } catch (e) {
                    console.log('error --> ', e);
                    d.reject(e);
                }

                return d.promise;
            },
            clear: function (collection) {
                var d = $q.defer();

                try {
                    licensuredb[collection].record.clear();
                    d.resolve();
                } catch (e) {
                    console.log('error --> ', e);
                    d.reject(e);
                }

                return d.promise;
            },
            getAll: function (collection) {
                var d = $q.defer();;

                try {
                    var result = licensuredb[collection].record.toArray();
                    d.resolve(result);
                } catch (e) {
                    console.log('error --> ', e);
                    d.reject(e);
                }

                return d.promise;
            },
            getOneWithIndex: function (collection, i, key) {
                var d = $q.defer();

                try {
                    var result;
                    licensuredb[collection].record.get(key, function (item) {
                        result = item;
                        d.resolve(result);
                    });

                } catch (e) {
                    console.log('error --> ', e);
                    d.reject(e);
                }

                return d.promise;
            },
            getWithIndexOnly: function (collection, i, only) {
                var d = $q.defer();

                try {
                    var result = [];
                    i = i.toUpperCase();
                    appraisaldb[collection].all(function (items) {
                        console.log(items);
                        for (var a = 0; a < items.length; a++) {
                            if (items[a][i] == only) {
                                result.push(items[a]);
                            }
                        }
                        d.resolve(result);
                    });

                } catch (e) {
                    console.log('error --> ', e);
                    d.reject(e);
                }

                return d.promise;
            },
            beginsWith: function (collection, i, lower, limit, filter) {
                //right now its not begins with. it is if it contain the string
                var d = $q.defer();
                lower = lower.toUpperCase();
                try {
                    var result = [];
                    var counter = 0;
                    appraisaldb[collection].all(function (all) {
                        for (var i = 0; i < all.length; i++) {
                            var temp = all[i].NAME;
                            temp = temp.toUpperCase();
                            if (temp.indexOf(lower) > -1) {
                                result.push(all[i]);
                                counter++;
                            }
                            if (counter == limit) {
                                break;
                            }
                        }
                        d.resolve(result);
                    });
                } catch (e) {
                    console.log('error --> ', e);
                    d.reject(e);
                }

                return d.promise;
            },
            getAllWithIndex: function (collection, index) {
                var d = $q.defer();
                index = index.toUpperCase();
                var result;
                try {
                    var a;
                    appraisaldb[collection].all(function (all) {
                        a = all;
                        result = merge_sort(a, index);
                        console.log('allwindex', index, result);
                        d.resolve(result);
                    });
                } catch (e) {
                    console.log('error --> ', e);
                    d.reject(e);
                }
                return d.promise;
            },
            getWithSortOrder: function (collection, i, id, sort) {
                var d = $q.defer();
                sort = sort.toUpperCase();
                var test = i.toUpperCase() + '_ID';
                try {
                    var a = [];
                    appraisaldb[collection].all(function (dbresult) {

                        for (var r = 0; r < dbresult.length; r++) {

                            if (dbresult[r][test] == id) {
                                a.push(dbresult[r]);
                            }

                        }
                        if (a === null || a.length == 0) {
                            d.resolve([]);
                        } else {
                            var result = merge_sort(a, sort);
                            console.log('wsortorder', result);
                            d.resolve(result);
                        }
                    });

                } catch (e) {
                    console.log('error --> ', e);
                    d.reject(e);
                }
                return d.promise;
            },
            saveFile: function (file) {
                var deferredFile = $q.defer();
                writeFileToStorage(file).then(function (filePointer) {
                    filePointer.ID = filePointer.FILE_ID;
                    try {
                        licensuredb['file'].save(filePointer);
                        deferredFile.resolve(filePointer);
                    } catch (e) {
                        console.log('error saving file', e);
                        deferredFile.reject(e); console.log('error --> ', e);
                    }
                });
                return deferredFile.promise;
            },
            deleteFile: function (file) {
                var d = $q.defer();
                deleteFileFromStorage(file.FILE_NAME).then(function () {
                    var query = 'FILE_NAME === ' + file.FILE_NAME;
                    try {
                        licensuredb['file'].get(query, function (item) {
                            licensuredb['file'].remove(item, function () {
                                console.log('file was deleted');
                                d.resolve();
                            });
                        });
                    } catch (e) {
                        d.reject(event);
                    }
                });
                return d.promise;
            },
            getFileUrlByID: function (fileID) {
                var deferredFileGet = $q.defer();
                try {
                    licensuredb['file'].get(fileID, function (file) {
                        getFileURL(file).then(function (fileURL) {
                            deferredFileGet.resolve(fileURL);
                        });
                    });
                } catch (e) {
                    deferredFileGet.reject(e); console.log('error --> ', e);
                }
                return deferredFileGet.promise;
            },
            getFileContent: function (fileID) {
                var d = $q.defer();
                licensuredb['file'].get(fileID, function (file) {
                    if (file.CONTENT !== null) {
                        if (!('name' in file.CONTENT)) {
                            file.CONTENT.name = file.FILE_NAME;
                        }
                        d.resolve(file.CONTENT);
                    } else {
                        filesystem.root.getFile(file.FILE_NAME, {}, function (fileEntry) {
                            fileEntry.file(function (fileObject) {
                                d.resolve(fileObject);
                            });
                        }, function (e) {
                            d.reject(e); console.log('error --> ', e);
                        });
                    }
                });
                return d.promise;
            }
        };
    }])
;